module.exports = __webpack_public_path__ + "static/media/galerija_2019 (21).e68f0d23.jpg";